import { useState } from 'react';

import useInterval from 'src/hooks/useInterval';

const getNow = () => Date.now();

/**
 * 현재 시간을 주기적으로 반환하는 커스텀 훅입니다.
 *
 * @param interval 밀리초 단위의 갱신 주기 (기본값: 1000)
 * @returns 현재 시간의 타임스탬프 (ms)
 */
const useNow = (interval = 1_000) => {
  const [now, setNow] = useState(getNow);

  useInterval(() => {
    setNow(getNow());
  }, interval);

  return now;
};

export default useNow;
